export const VIEW = {
  SET_VIEW_SIZE: 'view/set_view_size',
  SET_OVERLAY: 'view/set_overlay',
};

export type SetViewSizeAction = {
  type: typeof VIEW.SET_VIEW_SIZE;
  windowWidth: number;
};

export type ViewAction = SetViewSizeAction;

export function setViewSize(windowWidth: number): SetViewSizeAction {
  return {
    type: VIEW.SET_VIEW_SIZE,
    windowWidth,
  };
}
